export const environment = {
  URL: 'https://reports.dnv-spriced-cdbu.alpha.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.alpha.simadvisory.com',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'CHN_D_SPRICED_Client',
  const_url_report: 'https://reports.dnv-spriced-cdbu.alpha.simadvisory.com',
  const_url_process: 'https://reports.dnv-spriced-cdbu.alpha.simadvisory.com/',
};
